import { tokens } from "shared/components/Spor";

const breakpoints = {
  ...tokens.default.size.breakpoint,
  xxl: "2560",
};

export default breakpoints;
